import {
    IInteractionMetricsDistributions,
    IInteractionMetricsDistributionsResponse,
    InteractionMetric,
    Route,
} from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { decamelize } from "humps";
import { useQuery, UseQueryOptions } from "react-query";
import { axios } from "utilities/axios";
import { showServerError } from "utilities/show-server-error";

/**
 * Request metric distribution
 * @param metric            The metric name
 * @param searchParameters  Search query string
 */
export const requestMetricDistribution = async (
    url: string,
    metric: InteractionMetric,
    searchParameters: { [index: string]: any }
) => {
    const { data } = await axios.get<IInteractionMetricsDistributionsResponse<typeof metric>>(url, {
        params: { ...searchParameters, metric: decamelize(metric.toString()) },
    });

    return data.items;
};

/**
 * A query to request metric distribution from the backend.
 * @param metric            The metric name
 * @param searchParameters  Search query string with field details
 */
export const useMetricDistribution = (
    metric: InteractionMetric,
    searchParameters: { [index: string]: any },
    configuration: UseQueryOptions<IInteractionMetricsDistributions<typeof metric>, AxiosError<void>> = {}
) => {
    const url = Route.InteractionMetricsDistributions;
    return useQuery<IInteractionMetricsDistributions<typeof metric>, AxiosError<void>>(
        [url, metric, searchParameters],
        () => requestMetricDistribution(url, metric, searchParameters),
        {
            onError: showServerError,
            ...configuration,
        }
    );
};
